import {Module} from 'vuex';
import {RootState} from '@/types';
import UserAPI from '@/api/UserAPI';
import {
  SET_USER,
  SET_USERS,
  SET_CERTIFICATE,
  SET_USERS_FILE,
} from '@/store/mutationTypes';
import {namespace} from 'vuex-class';
import {Role} from '@/store/modules/roles';

export const usersModule = namespace('users');

export interface User {
  roles?: Role;

  [key: string]: any;
}
export interface File {
  [key: string]: any;
}

interface UserState {
  users: User[];
  user: User | null;
  certificate: User[];
  user_file: File[];
}

export default <Module<UserState, RootState>>{
  namespaced: true,
  state: {
    users: [],
    user: null,
    chemists: [],
    customers: [],
    doctors: [],
    certificate: [],
    user_file: [],
  },
  mutations: {
    [SET_USERS](state, data) {
      state.users = data;
    },
    [SET_USER](state, data) {
      state.user = data;
    },
    [SET_CERTIFICATE](state, data) {
      state.certificate = data;
    },
    [SET_USERS_FILE](state, data) {
      state.user_file = data;
    },
  },
  actions: {
    async all({commit}, params = {}) {
      try {
        const {data} = await UserAPI.all(params);
        if (!!params.paginate) {
          commit(SET_USERS, data.data);
        } else {
          commit(SET_USERS, data.data.data);
        }
        return data;
      } catch (e) {
        return e.response.data;
      }
    },
    async detailUser({commit}, params = {}) {
      try {
        const {data} = await UserAPI.getDetailUser(params);
        commit(SET_USERS, data.data);
        return data;
      } catch (e) {
        return e.response.data;
      }
    },
    async getUnregistered({commit}, params = {}) {
      try {
        const {data} = await UserAPI.getUnregistered(params);
        commit(SET_USERS, data.data.data);
        return data;
      } catch (e) {
        return e.response.data;
      }
    },
    async getUserFile({commit}, params = {}) {
      try {
        const data = await UserAPI.getUserFile(params);
        commit(SET_USERS_FILE, data.data.data);
        return data;
      } catch (e) {
        return e.response.data;
      }
    },
    async detail({commit}, id) {
      try {
        const {data} = await UserAPI.detail(id);
        commit(SET_USER, data.data);
        return data;
      } catch (e) {
        return e.response.data;
      }
    },
    async assignUser(_, payload) {
      try {
        const {data} = await UserAPI.assignUser(payload);
        return data;
      } catch (e) {
        return e.response;
      }
    },
    async uploadFile(_, payload: any) {
      try {
        const data = await UserAPI.upload(payload);
        return data;
      } catch (e) {
        return e.response;
      }
    },
    async updateSelfie(_, payload: any) {
      try {
        const data = await UserAPI.Selfie(payload);
        return data;
      } catch (e) {
        return e.response;
      }
    },
    async saveUrlFIle(_, payload: any) {
      try {
        const data = await UserAPI.uploadUrlFile(payload);
        return data;
      } catch (e) {
        return e.response;
      }
    },
    async saveCertificate(_, payload) {
      try {
        const data = await UserAPI.saveCertificate(payload);
        return data;
      } catch (e) {
        return e.response.data;
      }
    },
    async deleteCertificate(_, {id, payload}) {
      try {
        await UserAPI.deleteFile(payload);
        const data = await UserAPI.deleteCertificate(id);
        return data;
      } catch (e) {
        return e.response.data;
      }
    },
    async getCertificate({commit}, params = {}) {
      try {
        const {data} = await UserAPI.getCertificate(params);
        commit(SET_CERTIFICATE, data.data.data);
        return data;
      } catch (e) {
        return e.response.data;
      }
    },
  },
  getters: {},
};
